'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var formatGroupLabel = exports.formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = exports.getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = exports.getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = exports.isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};